export default __webpack_public_path__ + "static/interview-cc5e3ef69d2f4c2982bc8ee62aabfea0.png";